<div class="d-flex flex-column input-search-container-multi">
  <div class="d-flex input-search-box">
    <input
      type="text"
      [(ngModel)]="searchQuery"
      (input)="onSearch()"
      [placeholder]="placeholder"
    />
    <button-component
      [buttonClass]="'button button-dark btnImgLeft'"
      [isLeftImg]="false"
      [isRightImg]="false"
      Text="Search"
      [isButtonDisabled]="false"
      (OnClick)="onSearch()"
    ></button-component>
    <img
      *ngIf="searchQuery"
      class="clear-icon"
      src="./assets/icons/close.svg"
      alt=""
      (click)="clearSearch()"
    />
    <img class="search-icon" src="./assets/icons/search.svg" alt="" />
    <ul *ngIf="filteredItems.length > 0" class="dropdown">
      <li
        *ngFor="let item of filteredItems"
        [class.selected]="item.isChecked"
        (click)="toggleSelection(item.id)"
      >
        <label class="checkbox-container">
          <input
            type="checkbox"
            [checked]="item.isChecked"
            (change)="toggleSelection(item.id)"
          />
          <span class="checkmark checkmark-light"></span>
        </label>

        <div class="row w-100 align-items-center">
          <ng-content *ngFor="let key of objectKeys(item)">
            <div
              *ngIf="key !== 'id' && key !== 'isChecked'"
              class="col text-break"
            >
              {{ item[key] }}
            </div>
          </ng-content>
        </div>
      </li>
    </ul>
  </div>
</div>
